import Modal from "react-modal";
import "../../../styles/Modals.css";
import "../../../styles/Challenges.css";
import mealTypeLabels from "../mealTypeLabels";
import { formatJalali } from "../jalaliDate";

// calendar has exactly one recipe per (date, meal_type) slot - so a true
// "add alongside" isn't representable without breaking the existing
// calendar grid. The non-destructive default is "skip" (keep the user's
// existing meal); "replace" is the explicit, opt-in destructive choice.
function CalendarConflictModal({ show, onClose, conflicts, onResolve, busy }) {
  if (!conflicts) return null;

  return (
    <Modal isOpen={show} onRequestClose={onClose} className="modal" overlayClassName="overlay">
      <div className="modal-header">
        <h2>تداخل با تقویمت</h2>
        <a onClick={onClose}>
          <span className="icon-iconclose rectangle-1 heading-1 grey-3"></span>
        </a>
      </div>
      <div className="modal-body rightAlign max-height300">
        <p className="yekan grey-2 marginBottom1r">
          توی {conflicts.length} روز از این چالش، از قبل توی تقویمت غذا داری. چیکار کنیم؟
        </p>
        {conflicts.map((c, i) => (
          <div className="conflictRow" key={i}>
            <span className="caption-1 grey-2 yekan">
              {formatJalali(c.date)} - {mealTypeLabels[c.meal_type] || c.meal_type}
            </span>
            <span className="caption-1 grey-1 yekan">{c.existing_recipe_name}</span>
          </div>
        ))}
      </div>
      <div className="modal-footer">
        <a
          className="marginBottom0-4r fill-container radius1-5"
          style={{ opacity: busy ? 0.6 : 1 }}
          onClick={() => !busy && onResolve("skip")}
        >
          غذاهای فعلیم بمونن، این روزا رد شن
        </a>
        <a
          className="marginBottom0-4r challengeCheckinSecondary centerAlign"
          style={{ display: "block", opacity: busy ? 0.6 : 1 }}
          onClick={() => !busy && onResolve("replace")}
        >
          غذاهای چالش جایگزین بشن
        </a>
        <a
          className="caption-1 grey-2 centerAlign"
          style={{ display: "block", padding: "8px" }}
          onClick={onClose}
        >
          انصراف از شروع چالش
        </a>
      </div>
    </Modal>
  );
}

export default CalendarConflictModal;
